import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import { enums } from '@kattana-io/common';
import Text from '../../atoms/Text';
import { IStore } from '../../reducers';

import './styles.scss';

const Premium = () => {
  const loggedIn = useSelector((state: IStore) => state.auth.loggedIn);
  const plan = useSelector((state: IStore) => state.features.currentPlan);

  const navigate = useNavigate();

  if (plan === enums.PricingPlan.premium) {
    return null;
  }

  return (
    <>
      <div
        className={`premium_btn noselect ${
          !loggedIn ? 'premium_btn--disabled' : ''
        }`}
        onClick={loggedIn ? () => navigate('/subscription') : undefined}
        data-for='premium-tooltip'
        data-tip='You need to be authorized<br>for premium subscription'
      >
        <Text size={14}>Premium</Text>
      </div>
      <ReactTooltip
        id='premium-tooltip'
        place='bottom'
        effect='solid'
        className='text_tooltip'
        multiline={true}
        disable={loggedIn}
      />
    </>
  );
};

export default Premium;
